import { jsx as _jsx } from "react/jsx-runtime";
import CardActions from "@mui/material/CardActions";
function stopPropagation(e) {
    e.stopPropagation();
}
/**
 * Wrapper for a single thumbnail action without padding
 *
 * Since the CardActionArea is wrapped around the whole card, we need to stop bubbling here.
 * @category UI
 * @param props
 * @returns
 */
export function ThumbnailAction(props) {
    return (_jsx(CardActions, { onMouseDown: stopPropagation, onClick: stopPropagation, sx: { p: 0, m: 0, display: "contents" }, children: props.children }));
}
//# sourceMappingURL=ThumbnailAction.js.map